import * as React from "react"

const Switch = React.forwardRef(({ className, checked, onCheckedChange, disabled, ...props }, ref) => {
  const bgColor = checked ? '#0056A6' : '#9ca3af';
  const thumbPosition = checked ? '22px' : '0px';
  
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      disabled={disabled}
      ref={ref}
      onClick={() => onCheckedChange?.(!checked)}
      style={{
        width: '48px',
        height: '26px',
        padding: '3px',
        borderRadius: '13px',
        backgroundColor: bgColor,
        border: 'none',
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.5 : 1,
        transition: 'background-color 0.2s ease-in-out',
        display: 'inline-flex',
        alignItems: 'center',
        flexShrink: 0,
        boxSizing: 'border-box',
        position: 'relative',
      }}
      {...props}
    >
      <span
        style={{
          width: '20px',
          height: '20px',
          borderRadius: '50%',
          backgroundColor: '#ffffff',
          boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
          transform: `translateX(${thumbPosition})`,
          transition: 'transform 0.2s ease-in-out',
          display: 'block',
          flexShrink: 0,
        }}
      />
    </button>
  );
})
Switch.displayName = "Switch"

export { Switch }
